<template>
  <footer
    id="footer-section"
    class="w-full bg-unify-blue-800 text-white p-4 sm:p-6 inverse-surface"
  >
    <!-- Desktop: logo+copyright grouped on the left, links pinned to the right -->
    <div class="hidden sm:flex items-center justify-between gap-4 max-w-5xl mx-auto">
      <div class="flex items-center gap-8">
        <ImageComponent
          :src="unifyWhiteLogo"
          alt="Unify America"
          class="max-w-16"
        />
        <p class="text-sm">
          {{ t('common.footer.copyright', { year: currentYear }) }}
        </p>
      </div>

      <div class="flex items-center gap-4">
        <ButtonInput
          id="terms-of-service-button-desktop"
          data-gtm-id="terms-of-service-button"
          :label="t('common.footer.termsOfService')"
          class="text-white hover:underline text-sm"
          variant="link"
          as="a"
          target="_blank"
          :href="UNIFY_AMERICA_URLS.TERMS_OF_SERVICE"
        />
        <ButtonInput
          id="privacy-policy-button-desktop"
          data-gtm-id="privacy-policy-button"
          :label="t('common.footer.privacyPolicy')"
          class="text-white hover:underline text-sm"
          variant="link"
          as="a"
          target="_blank"
          :href="UNIFY_AMERICA_URLS.PRIVACY_POLICY"
        />
      </div>
    </div>

    <!-- Mobile: logo on the left, copyright with the links in a row below it on the right -->
    <div class="flex sm:hidden items-start gap-2 max-w-5xl mx-auto">
      <ImageComponent
        :src="unifyWhiteLogo"
        alt="Unify America"
        class="max-w-10 shrink-0"
      />

      <div class="flex flex-col gap-2">
        <p class="text-xs">
          {{ t('common.footer.copyright', { year: currentYear }) }}
        </p>

        <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
          <ButtonInput
            id="terms-of-service-button-mobile"
            data-gtm-id="terms-of-service-button"
            :label="t('common.footer.termsOfService')"
            class="text-white hover:underline !text-xs"
            variant="link"
            as="a"
            target="_blank"
            :href="UNIFY_AMERICA_URLS.TERMS_OF_SERVICE"
          />
          <ButtonInput
            id="privacy-policy-button-mobile"
            data-gtm-id="privacy-policy-button"
            :label="t('common.footer.privacyPolicy')"
            class="text-white hover:underline !text-xs"
            variant="link"
            as="a"
            target="_blank"
            :href="UNIFY_AMERICA_URLS.PRIVACY_POLICY"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import unifyWhiteLogo from '@/assets/images/unifyAmericaLogos/UA-Big U Symbol White.png';
import { UNIFY_AMERICA_URLS } from '@/constants';

const t: any = inject('t');
const currentYear = new Date().getFullYear();
</script>

<style scoped>
/* The global `.p-button .p-button-label { font-weight: bold !important; }` rule
   (styles.scss) needs an equal-or-higher specificity !important to override, so
   these are targeted by ID rather than a plain utility class. */
:deep(#terms-of-service-button-desktop .p-button-label),
:deep(#privacy-policy-button-desktop .p-button-label),
:deep(#terms-of-service-button-mobile .p-button-label),
:deep(#privacy-policy-button-mobile .p-button-label) {
  font-weight: normal !important;
}
</style>
